var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "astro-dialog-container" },
    [
      _vm.isMobile
        ? _c(
            "div",
            {
              staticClass: "AstroCalendarFullNotice-mobile",
              on: {
                mousemove: _vm.handleMove,
                touchmove: _vm.handleMove,
                mouseup: _vm.handleEnd,
                touchend: _vm.handleEnd,
                mouseleave: _vm.handleEnd
              }
            },
            [
              _c(
                "div",
                { staticClass: "content-layer", style: _vm.contentStyle },
                [
                  _c("div", { staticClass: "inner-layout" }, [
                    _c(
                      "div",
                      { staticClass: "astroCalendarNoticeDialog__box" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "astroCalendarNoticeDialog__box__picArea"
                          },
                          [_c("img", { attrs: { src: _vm.topicImg, alt: "" } })]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "astroCalendarNoticeDialog__box__date"
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(_vm.todayDate) + " "
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.moment().format("ddd")))
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "astroCalendarNoticeDialog__box__title"
                          },
                          [
                            _vm._v(
                              "\n            ★ " +
                                _vm._s(
                                  _vm.calendarInterpretation &&
                                    _vm.calendarInterpretation.Highlight
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "astroCalendarNoticeDialog__box__teacher"
                          },
                          [
                            _vm._m(0),
                            _c("div", { staticClass: "teacher__content" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.calendarInterpretation &&
                                      _vm.calendarInterpretation.Remind
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "astroCalendarNoticeDialog__box__btn",
                            on: { click: _vm.toCalendar }
                          },
                          [_vm._v("\n            前往共时历\n          ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "astroCalendarNoticeDialog__box__textBtn",
                            on: { click: _vm.toAstrolabe }
                          },
                          [_vm._v("\n            探索星盘\n          ")]
                        )
                      ]
                    )
                  ])
                ]
              ),
              _c("div", {
                staticClass: "curl-layer",
                class: { animating: _vm.isAnimating },
                style: _vm.curlStyle
              }),
              _c("div", {
                staticClass: "trigger-zone",
                on: {
                  mousedown: function($event) {
                    $event.stopPropagation()
                    return _vm.handleStart.apply(null, arguments)
                  },
                  touchstart: function($event) {
                    $event.stopPropagation()
                    return _vm.handleStart.apply(null, arguments)
                  }
                }
              })
            ]
          )
        : _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _c("Fixed_popup", { staticClass: "astroCalendarNoticeDialog" }, [
                _c("div", { staticClass: "astroCalendarNoticeDialog__box" }, [
                  _c(
                    "div",
                    { staticClass: "astroCalendarNoticeDialog__box__picArea" },
                    [_c("img", { attrs: { src: _vm.topicImg, alt: "" } })]
                  ),
                  _c(
                    "div",
                    { staticClass: "astroCalendarNoticeDialog__box__date" },
                    [
                      _vm._v("\n          " + _vm._s(_vm.todayDate) + " "),
                      _c("span", [_vm._v(_vm._s(_vm.moment().format("ddd")))])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "astroCalendarNoticeDialog__box__title" },
                    [
                      _vm._v(
                        "\n          ★ " +
                          _vm._s(
                            _vm.calendarInterpretation &&
                              _vm.calendarInterpretation.Highlight
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "astroCalendarNoticeDialog__box__teacher" },
                    [
                      _c("div", { staticClass: "teacher__header" }, [
                        _c("div", { staticClass: "teacher__header__pic" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../cn-demo-assets/Logo.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _c("div", { staticClass: "teacher__header__title" }, [
                          _vm._v("星学会的一句叮咛")
                        ])
                      ]),
                      _c("div", { staticClass: "teacher__content" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.calendarInterpretation &&
                                _vm.calendarInterpretation.Remind
                            ) +
                            "\n          "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "astroCalendarNoticeDialog__box__btn",
                      on: { click: _vm.toCalendar }
                    },
                    [_vm._v("\n          前往共时历\n        ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "astroCalendarNoticeDialog__box__textBtn",
                      on: { click: _vm.toAstrolabe }
                    },
                    [_vm._v("\n          探索星盘\n        ")]
                  )
                ])
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "teacher__header" }, [
      _c("div", { staticClass: "teacher__header__pic" }, [
        _c("img", {
          attrs: { src: require("../../../cn-demo-assets//Logo.png"), alt: "" }
        })
      ]),
      _c("div", { staticClass: "teacher__header__title" }, [
        _vm._v("星学会的一句叮咛")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }